import { render, staticRenderFns } from "./guohu.vue?vue&type=template&id=d2d0c6b4&scoped=true&"
import script from "./guohu.vue?vue&type=script&lang=js&"
export * from "./guohu.vue?vue&type=script&lang=js&"
import style0 from "./guohu.vue?vue&type=style&index=0&id=d2d0c6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d0c6b4",
  null
  
)

export default component.exports